import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-14 md:py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20abstract%20Korean%20aesthetic%20background%20with%20flowing%20gradients%20in%20warm%20coral%20and%20cream%20tones%2C%20gentle%20ink%20wash%20textures%2C%20minimal%20elegant%20design%2C%20dreamy%20atmosphere&width=1600&height=600&seq=cta-bg-hanman&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-500/90 to-primary-600/80"></div>
      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3">
          开始你的韩漫阅读之旅
        </h2>
        <p className="text-white/80 text-sm md:text-base mb-6 max-w-xl mx-auto">
          韩漫画网每日更新海量高清韩国漫画，免费在线阅读，随时随地畅享视觉盛宴
        </p>
        <Link
          to="/category/love"
          className="inline-flex items-center gap-2 bg-background-50 text-primary-500 px-8 py-3 rounded-full text-sm font-semibold hover:bg-background-50/90 transition-all duration-300 hover:scale-105 whitespace-nowrap"
        >
          立即探索
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
        </Link>
      </div>
    </section>
  );
}